import { createFileRoute } from '@tanstack/react-router'

import EditPenyuluhPusatPage from '@/components/pages/backoffice/_klb-penyuluh/_pusat/_$pusatId/edit/containers/EditPenyuluhProvinsiPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/pusat/$pusatId/edit/'
)({
  component: EditPenyuluhPusatPage
})
